import { SignInApiSdk } from '../api/SignInApiSdk';
import { SignInRepository } from '../internal/repositories/SignInRepository';
import { ConfigStore } from './ConfigStore';
import { Container } from 'hypo-container';
import { ServiceBusController } from './ServiceBusController';
import { SignInFormService } from './SignInFormService';
import { getDecorators } from 'elc-service';
import { root } from 'elc-universal-utils';
import { SingleSignOnViewController } from '../internal/controllers/SingleSignOnViewController';
import { SignInFormViewController } from '../internal/controllers/SignInFormViewController';
import { NavLinkViewController } from '../internal/controllers/NavLinkViewController';
import { AuthSession } from '../internal/domain/entities/AuthSession';
import { AuthSessionRepository } from '../internal/repositories/AuthSessionRepository';
import { GuestRepository } from '../internal/repositories/GuestRepository';
import { GuestUser } from '../internal/domain/entities/GuestUser';
import { GuestFormViewController } from '../internal/controllers/GuestFormViewController';
import { SignInModalErrorController } from '../internal/controllers/SignInModalErrorController';

export const diContainer = new Container();
export const serviceNames = {
    signInApiSdk: 'SIGN_IN_API_SDK',
    configStore: 'CONFIG_STORE',
    signInRepository: 'SIGN_IN_REPOSITORY',
    signInModalErrorController: 'SIGN_IN_MODAL_ERROR_CONTROLLER',
    httpTransport: 'HTTP_TRANSPORT',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    signInFormService: 'SIGN_IN_FORM_SERVICE',
    authSession: 'AUTH_SESSION',
    authSessionRepository: 'AUTH_SESSION_REPOSITORY',
    singleSignOnViewController: 'SINGLE_SIGN_ON_VIEW_CONTROLLER',
    signInFormViewController: 'SIGN_IN_FORM_VIEW_CONTROLLER',
    navLinkViewController: 'NAV_LINK_VIEW_CONTROLLER',
    guestFormViewController: 'GUEST_FORM_VIEW_CONTROLLER',
    guestRepository: 'GUEST_REPOSITORY',
    guestUser: 'GUEST_USER'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(serviceNames.configStore, diContainer.factory(c => new ConfigStore(c.config)))
    .register(serviceNames.httpTransport, c => {
        return root.HttpTransport;
    })
    .register(serviceNames.signInApiSdk, c => {
        const config = {
            httpTransport: c.get(serviceNames.httpTransport)
        };

        return new SignInApiSdk(config);
    })
    .register(
        serviceNames.serviceBusController,
        c =>
            new ServiceBusController(
                c.get(serviceNames.authSessionRepository),
                c.get(serviceNames.guestRepository)
            )
    )
    .register(
        serviceNames.signInFormService,
        c =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            new SignInFormService((config: any) => {
                setConfig(config);

                return c.get(serviceNames.serviceBusController);
            })
    )
    .register(
        serviceNames.signInModalErrorController,
        c =>
            new SignInModalErrorController({
                signInRepository: c.get(serviceNames.signInRepository)
            })
    )
    .register(serviceNames.guestRepository, c => new GuestRepository())
    .register(serviceNames.guestUser, c => new GuestUser(''))
    .register(serviceNames.signInRepository, c => new SignInRepository())
    .register(serviceNames.authSessionRepository, c => new AuthSessionRepository())
    .register(serviceNames.authSession, c => new AuthSession(null, null, null))
    .register(
        serviceNames.singleSignOnViewController,
        diContainer.factory(
            c =>
                new SingleSignOnViewController({
                    guestRepository: c.get(serviceNames.guestRepository)
                })
        )
    )
    .register(
        serviceNames.signInFormViewController,
        diContainer.factory(
            c =>
                new SignInFormViewController({
                    signInRepository: c.get(serviceNames.signInRepository)
                })
        )
    )
    .register(
        serviceNames.navLinkViewController,
        diContainer.factory(c => new NavLinkViewController())
    )
    .register(
        serviceNames.guestFormViewController,
        diContainer.factory(
            c =>
                new GuestFormViewController({
                    guestRepository: c.get(serviceNames.guestRepository)
                })
        )
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
